export default "__VITE_ASSET__CnSJJlqZ__"